import React from 'react';

export const NoRecordFound = () => {
  return <div className="text--c text--black-600">No Record Found</div>;
};
